// Module
var code = `<div class="row">
	<amt-form-inline
		name='life_time.LTVPredictionCreateForm'
		on-submit='start_ltvprediction_task(model)'
		options='{supressPropertyTitles: true}'
	></amt-form-inline>
</div>
`;
// Exports
module.exports = code;